module.exports = __webpack_public_path__ + "static/media/purple2.4b6fa17b.png";